import { tr, trf } from './i18n';

/** Les moyens de paiement d'une dépense, d'une facture de fournisseur ou de sous-traitant. */
export const MOYENS_PAIEMENT = [
  { k: 'banque', lib: '🏦 Banque' },
  { k: 'carte', lib: '💳 Carte' },
  { k: 'especes', lib: '💵 Espèces' },
];

/** « banque » écrit « Banque », dans la langue de l'écran. */
export const libelleMoyen = (k) => {
  const m = MOYENS_PAIEMENT.find((x) => x.k === k);
  return m ? tr(m.lib).replace(/^\S+\s/, '') : '';
};

/** « Payé le 05.08.2026 · Banque », ou '' si pas payé. */
export const textePaye = (payeLe, payePar) =>
  payeLe
    ? trf('Payé le {0}', payeLe) + (libelleMoyen(payePar) ? ' · ' + libelleMoyen(payePar) : '')
    : '';
